<template>
  <v-form
    :lazy-validation="true"
    @submit.prevent="handleSubmit"
    v-model="valid"
  >
    <v-card>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>{{ $t("common.edit") }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
      </v-toolbar>
      <v-card-text>
        <v-text-field
          :label="$t('application.fields.name')"
          name="name"
          prepend-icon="domain"
          type="text"
          v-model="appName"
          :rules="nameRules"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" type="submit" x-large>{{
          $t("common.update")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "ApplicationEdit",
  data() {
    return {
      submitted: false,
      valid: false,
      appName: "",
      id: null,
      nameRules: [
        v => !!v || this.$t("application.validation.nameRequired"),
        v => (v && v.length <= 255) || this.$t("application.validation.nameMax")
      ]
    };
  },
  computed: {
    ...mapState("users", [
      "status",
      "currentUser",
      "userCompany",
      "hasCompany"
    ]),
    ...mapState("applications", { application: "currentApplication" })
  },
  methods: {
    ...mapActions("applications", {
      updateApplication: "update",
      getApplication: "getApplication"
    }),
    handleSubmit() {
      this.submitted = true;

      let name = this.appName;

      if (name && this.id !== null)
        this.updateApplication({
          id: this.id,
          applicationPayload: { name }
        }).then(() => {
          this.$router.push("/application");
        });
    }
  },

  async created() {
    if (
      this.application !== undefined &&
      this.application.applicationId !== this.$route.params.id
    ) {
      await this.getApplication(this.$route.params.id);
      this.appName = this.application.name;
      this.id = this.application.applicationId;
    }
  }
};
</script>

<style></style>
